import Grid2 from '@mui/material/Grid2'; // Importa Grid2 de Material-UI

const Grid = Grid2;

export default Grid;